import React from "react";
import { Select, Tooltip } from "antd";
import { SelectTab,ToolTipContainer } from "./style";
import { connect } from "react-redux";
import Preloader from "../../../../../../CommonComponents/Preloader/Preloader";

const Option = Select.Option;

class MultiSelect extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      size: "large",
      children: this.props.options,
      optionsAnt: [],
      optionInfo: {
        "Research proceeding": "Due diligence has begun.",
        "Entered":
          "At managers’ request, accounts or grantee organizations are placed on hold.",
        "Research complete": "Due diligence was completed.",
        "Approved": "Grant recommendation was approved.",
        "Cancelled": "Grant was cancelled.",
        "Reversed": `Grant check was stopped and adjusted back into the donor’s account or the Grant check was stopped and a new grant was issued and backdated to the original trade date.`,
        "Denied": "Grant was denied.",
        "Payment issued": "Grant check was issued.",
        "Payment completed": "Grant check is deposited."
      },
      info: false,
      selected: []
    };
    this.clearData = this.clearData.bind(this);
  }


  componentDidMount()
  {
    let idNode = document.querySelector(`#ga-select-input${this.props.id} input` );
    if(idNode)
    {
      idNode.setAttribute("id",`ga-select-input${this.props.id}input`);
      idNode.setAttribute("aria-label","grant activity input ")
    }
  }

  clearData = e => {
    if (this.props.cleared) {
      this.props.clearedFunc(false);
      return this.setState({ selected: [] });
    } else {
      return this.setState({ selected: e }, this.props.handleDropper(e));
    }
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.cleared !== prevProps.cleared) {
      if (this.props.cleared === true) {
        this.props.clearedFunc(false);
        return this.setState({ selected: [] });
      }
    }

  }

  render() {
    const { options } = this.props;
    const { placeholder } = this.props;
    let filterOptions =
      options &&
      options.map((x, index) => (
        <Option key={index} value={x}>
          <ToolTipContainer  getPopupContainer={() => document.getElementById(`ga-select-input${this.props.id||""}`)}
           title={this.state.optionInfo[x]} 
           placement="right"
           overlayClassName="ga-tooltip">{x}</ToolTipContainer>
        </Option>
      ));

    return (
      <div>
        {filterOptions && filterOptions.length ? (
          <SelectTab
            className="grantSelectBox"
            id={`ga-select-input${this.props.id||""}`}
            mode="multiple"
            getPopupContainer={trigger => trigger.parentNode}
            placeholder={placeholder}
            showArrow={true}
            value={this.props.cleared ? [] : this.state.selected}
            onChange={e => {
              this.clearData(e);
            }}
          >
            {filterOptions.length ? filterOptions : null}
          </SelectTab>
        ) : (
          <SelectTab
          className="grantSelectBox" 
          id={`ga-select-input${this.props.id||""}`}
            mode="multiple"
            getPopupContainer={trigger => trigger.parentNode}
            placeholder={placeholder}
            showArrow={true}
            value={undefined}
          >
            {null}
          </SelectTab>
        )}
      </div>
    );
  }
}

export default MultiSelect;
